module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.b38ef310.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/stroke7/fonts/Pe-icon-7-stroke.woff?d7yf1v
// module id = 2221
// module chunks = 228